import React, { useState } from 'react'
import CurrencyInput from 'react-currency-input-field'
import * as styles from './InputForm.module.scss'
import { useCalc } from '../../context/CalcContext'

const InputForm = () => {
  const [errorMessage, setErrorMessage] = useState('')
  const { setMrr, setMom, setMe, setGm, setCb } = useCalc()

  return (
    <div className={styles.inputFormWrap}>
      <form>
        <div className={styles.formGroup}>
          <CurrencyInput
            id="fejorn-calc-mrr"
            name="mrr"
            placeholder="Enter your MRR"
            defaultValue={100000}
            prefix="€ "
            decimalsLimit={2}
            onValueChange={(value) => setMrr(parseFloat(value))}
          />
          <label htmlFor="fejorn-calc-mrr">Monthly Recurring Revenue</label>
          <div className="invalid-feedback">{errorMessage || ''}</div>
        </div>
        <div className={styles.formGroup}>
          <CurrencyInput
            id="fejron-calc-mom"
            name="mom"
            placeholder="Enter your MoM growth rate"
            defaultValue={4}
            suffix="%"
            decimalsLimit={2}
            onValueChange={(value) => setMom(parseFloat(value) / 100)}
          />
          <label htmlFor="fejorn-calc-mrr">MoM growth rate</label>
          {/* <div className="invalid-feedback">{errorMessage || ''}</div> */}
        </div>
        <div className={styles.formGroup}>
          <CurrencyInput
            id="fejorn-calc-me"
            name="me"
            placeholder="Enter your monthly expenses"
            defaultValue={150000}
            prefix="€ "
            decimalsLimit={2}
            onValueChange={(value) => setMe(parseFloat(value))}
          />
          <label htmlFor="fejorn-calc-mrr">Monthly expenses</label>
          {/* <div className="invalid-feedback">{errorMessage || ''}</div> */}
        </div>
        <div className={styles.formGroup}>
          <CurrencyInput
            id="fejorn-calc-gm"
            name="gm"
            placeholder="Enter your gross margin"
            defaultValue={70}
            suffix="%"
            decimalsLimit={2}
            onValueChange={(value) => setGm(parseFloat(value) / 100)}
          />
          <label htmlFor="fejorn-calc-mrr">Gross margin</label>
          {/* <div className="invalid-feedback">{errorMessage || ''}</div> */}
        </div>
        <div className={styles.formGroup}>
          <CurrencyInput
            id="fejorn-calc-cb"
            name="cb"
            placeholder="Enter your cash balance"
            defaultValue={600000}
            prefix="€ "
            decimalsLimit={2}
            onValueChange={(value) => setCb(parseFloat(value))}
          />
          <label htmlFor="fejorn-calc-mrr">Cash balance</label>
          {/* <div className="invalid-feedback">{errorMessage || ''}</div> */}
        </div>
      </form>
    </div>
  )
}

export default InputForm
